import React from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import { IContactItemProps } from './types';

function ContactItem({ item }: IContactItemProps) {
  return (
    <div className={cx(s.contactItem, 'custom-contacts-item')}>
      {item.title && (
        <div className={cx(s.itemBody, 'custom-contacts-item-body')}>
          <Text className={cx(s.itemBodyText, 'custom-contacts-item-body-text')}>{item.title}</Text>
        </div>
      )}
      {item.name && (
        <div className={cx(s.itemBody, 'custom-contacts-item-body')}>
          <Text className={cx(s.itemBodyText, 'custom-contacts-item-body-text')}>{item.name}</Text>
        </div>
      )}
      {item.email && (
        <div className={cx(s.itemBody, 'custom-contacts-item-body')}>
          <Text className={cx(s.itemBodyText, 'custom-contacts-item-body-text')}>Email: {item.email}</Text>
        </div>
      )}
      {item.phone && (
        <div className={cx(s.itemBody, 'custom-contacts-item-body')}>
          <Text className={cx(s.itemBodyText, 'custom-contacts-item-body-text')}>Tel: {item.phone}</Text>
        </div>
      )}
    </div>
  );
}

export default ContactItem;
